import {
    createBaseThemeOptions,
    createUnifiedTheme,
    defaultTypography,
    genPageTheme,
    palettes,
    shapes
} from '@backstage/theme';
import TOTVSRegularFont from '../assets/fonts/TOTVS-Regular.ttf';
import TOTVSBoldFont from '../assets/fonts/TOTVS-Bold.ttf';
import TOTVSLightFont from '../assets/fonts/TOTVS-Light.ttf';

const fontTOTVSRegular = {
    fontFamily: 'TOTVS',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `
        local('TOTVS'),
        url(${TOTVSRegularFont}) format('truetype')
    `,
};

const fontTOTVSBold = {
    fontFamily: 'TOTVS',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 700,
    src: `
        local('TOTVS'),
        url(${TOTVSBoldFont}) format('truetype')
    `,
};

const fontTOTVSLight = {
    fontFamily: 'TOTVS',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 200,
    src: `
        local('TOTVS'),
        url(${TOTVSLightFont}) format('truetype')
    `,
};

// const TOTVSColors = {
//     azulescuro:	#002233;
//   --azul:	#00dbff;
//   /*SECONDARY*/
//   --roxo:	#a44dff;
//   /*COMPLEMENTARY*/
//   --verde:	#00ffd4;
//   --limao:	#d9ff65;
//   --laranja:	#ff8900;
//   --rosa:	#ff009e;
// };

export const TotvsLightTheme = createUnifiedTheme({
    ...createBaseThemeOptions({
        palette: {
            ...palettes.light,
            primary: {
                main: '#002233',
            },
            secondary: {
                main: '#a44dff',
            },
            error: {
                main: '#d58581',
            },
            warning: {
                main: '#f1cd6a',
            },
            info: {
                main: '#7996d7',
            },
            success: {
                main: '#41b483',
            },
            background: {
                default: '#ededed',
                paper: '#fbfbfb',
            },
            banner: {
                info: '#7996d7',
                warning: '#f1cd6a',
                error: '#d58581',
                text: '#002233',
                link: '#0079b8',
            },
            link: '#0079b8',
            linkHover: '#004064',
            errorBackground: '#d58581',
            warningBackground: '#f1cd6a',
            infoBackground: '#002233',
            navigation: {
                background: '#002233',
                indicator: '#0d729c',
                color: '#fbfbfb',
                selectedColor: '#ffffff',
            },
        },
        typography: {
            ...defaultTypography,
            fontFamily: 'TOTVS, sans-serif',

        },
        fontFamily: 'TOTVS, sans-serif',
    }),
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                '@font-face': [fontTOTVSRegular, fontTOTVSBold, fontTOTVSLight],
            },

        },
        BackstageSidebarItem: {
            styleOverrides: { 
                open: { 
                    textDecoration: 'none' 
                } 
            }
        }
    },
    defaultPageTheme: 'home',
    pageTheme: {
        home: genPageTheme({ colors: ['#363636', '#002233', '#363636'], shape: shapes.wave2 }),
        website: genPageTheme({ colors: ['#363636', '#00dbff', '#363636'], shape: shapes.wave2 }),
        system: genPageTheme({ colors: ['#363636', '#a44dff', '#363636'], shape: shapes.wave2 }),
        product: genPageTheme({ colors: ['#363636', '#ff8900', '#363636'], shape: shapes.wave2 }),
        problem: genPageTheme({ colors: ['#363636', '#d9ff65', '#363636'], shape: shapes.wave2 })
    },
});